import { request } from "./client";

export type AccountOrganization = {
  id: string;
  name?: string | null;
  phone_number?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  region?: string | null;
  postal_code?: string | null;
  country?: string | null;
  bandsintown_app_id?: string | null;
  spotify_client_id?: string | null;
  has_spotify_client_secret?: boolean;
  press_rss_feeds?: string[] | null;
  press_tavily_queries?: string[] | null;
  lead_target_markets?: string[] | null;
  lead_target_states?: string[] | null;
  lead_target_countries?: string[] | null;
  account_type?: string | null;
  multi_artist_available?: boolean | null;
  crm_sync_enabled?: boolean | null;
};

export type AccountProfile = {
  user: {
    id: string;
    email?: string | null;
    name: string;
    role: string;
    first_name?: string | null;
    last_name?: string | null;
    phone_number?: string | null;
    user_type: string;
    is_owner: boolean;
    avatar_url?: string | null;
    two_fa_enabled?: boolean;
  };
  organization?: AccountOrganization | null;
  permissions: string[];
  teams?: { id: string; name?: string | null }[];
};

export type AccountUpdatePayload = {
  email?: string;
  first_name?: string | null;
  last_name?: string | null;
  phone_number?: string | null;
  organization_name?: string | null;
  organization_phone_number?: string | null;
  organization_address?: {
    line1?: string | null;
    line2?: string | null;
    city?: string | null;
    region?: string | null;
    postal_code?: string | null;
    country?: string | null;
  } | null;
  tavily_api_key?: string | null;
  bandsintown_app_id?: string | null;
  spotify_client_id?: string | null;
  spotify_client_secret?: string | null;
  press_rss_feeds?: string[];
  press_tavily_queries?: string[];
  lead_target_markets?: string[];
  lead_target_states?: string[];
  lead_target_countries?: string[];
  account_type?: string | null;
  crm_sync_enabled?: boolean | null;
};

export async function fetchCurrentAccount(): Promise<AccountProfile> {
  return request<AccountProfile>("/auth/me");
}

export async function updateAccount(payload: AccountUpdatePayload): Promise<AccountProfile> {
  return request<AccountProfile>("/auth/me", {
    method: "PATCH",
    body: payload,
  });
}

export async function uploadAccountAvatar(file: File): Promise<AccountProfile> {
  const formData = new FormData();
  formData.append("file", file);
  return request<AccountProfile>("/auth/me/avatar", {
    method: "POST",
    body: formData,
  });
}

export type PasswordChangePayload = {
  current_password: string;
  new_password: string;
  confirm_password: string;
};

export async function changePassword(payload: PasswordChangePayload): Promise<{ status: string }> {
  return request<{ status: string }>("/auth/me/password", {
    method: "POST",
    body: payload,
  });
}
